function init_wishlist() {
      document.addEventListener('shopify-wishlist:updated', (event) => {
        console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
      });
      const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
      const LOCAL_STORAGE_DELIMITER = ',';
      const BUTTON_ACTIVE_CLASS = 'active';
      const GRID_LOADED_CLASS = 'loaded';
      
      const selectors = {
        button: '[button-wishlist]'
      };
      const setupButtons = (buttons) => {
        buttons.forEach((button) => {
          const productHandle = button.dataset.productHandle || false;
          if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
          if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
          button.addEventListener('click', () => {
            updateWishlist(productHandle);
            button.classList.toggle(BUTTON_ACTIVE_CLASS);
          });
        });
      };
    const initButtons = () => {
      const buttons = document.querySelectorAll(selectors.button) || [];
      if (buttons.length) setupButtons(buttons);
      else return;
      const event = new CustomEvent('shopify-wishlist:init-buttons', {
        detail: { wishlist: getWishlist() }
      });
      document.dispatchEvent(event);
    };
    const getWishlist = () => {
      const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
      if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
      return [];
    };
    const setWishlist = (array) => {
      const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
      if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
      else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    
      const event = new CustomEvent('shopify-wishlist:updated', {
        detail: { wishlist: array }
      });
      document.dispatchEvent(event);
      return wishlist;
    };
    const updateWishlist = (handle) => {
      const wishlist = getWishlist();
      const indexInWishlist = wishlist.indexOf(handle);
      if (indexInWishlist === -1) wishlist.push(handle);
      else wishlist.splice(indexInWishlist, 1);
      return setWishlist(wishlist);
    };
    const wishlistContains = (handle) => {
      const wishlist = getWishlist();
      return wishlist.includes(handle);
    };
    const resetWishlist = () => {
      return setWishlist([]);
    };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
   }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }
  
  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
      StampedFn.loadBadges();
      init_wishlist();
      initButtons()
  }
  
  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'dm-mob-filtering-input') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}
 
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

  // const labels = document.querySelectorAll('.facet-checkbox');
  // labels.forEach((label) => {
  //   label.addEventListener('click', () => {
  //     const checkbox = label.querySelector('input[type="radio"]');
  //     if (checkbox.checked) {
  //       label.classList.add('facet-checkbox--active');
  //       console.log(checkbox);
  //     } 
  //     else {
  //       label.classList.remove('facet-checkbox--active');
  //     }

  //     const summaries = document.querySelectorAll('.facets__summary');
  //     summaries.forEach((summary) => {
  //       summary.addEventListener('click', () => {
  //         const details = summary.parentElement; 
  //         console.log(details);
  //         const text = summary.querySelector('.selected-item1');

  //         console.log('summary toggle');

  //         setTimeout(() => {
  //           if (details.open) text.style.setProperty('display', 'none');
  //           else text.style.removeProperty('display');
  //         }, 100);
  //       });
  //     });

  //   });
  // });

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}
customElements.define('facet-remove', FacetRemove);

// Custom Filters JS
$(document).on('click', '.dm-desk-filtering-input', function() {
  var $box = $(this);
  if ($box.is(":checked")) {
    var group = ".dm-desk-filtering-input[name='" + $box.attr("name") + "']";
    $(group).prop("checked", false);
    $box.prop("checked", true);
  } else {
    $box.prop("checked", false);
  }
});

$(document).on('click', '.dm-mobile-factes-sorting .facets__summary', function() {
   $(this).toggleClass("dm-mobile-sorting-open");
   $(this).next().toggleClass("dm-active");
});

$(document).on('click', '.dm-mobile-facets-filtering .facets__summary', function() {
   $(this).toggleClass("dm-mobile-filtering-open");
   $(this).next().toggleClass("dm-active");
});

$(document).on('click', '.dm-mobile-sorting-options .dm-desk-sorting-label', function() {
   $(".dm-mobile-sorting-options .dm-desk-sorting-input").removeAttr("checked")
   $(this).prev().attr("checked", "checked");
   setTimeout(function(){
    $('.mobile-facets__footer .button').click();
   }, 1000)
});

$(document).on('click', '.dm-mob-filtering-label', function() {
  var $this=$(this);
  var $input=$this.prev();
  var $inputValue=$input.val();
  var filtersArray=$this.parents(".dm-mobile-filtering-options").find(".list-menu__item");
  filtersArray.each(function() {
    var $dataName= $(this).children("input").val();
    if($dataName!=$inputValue) {
      $(this).children(".dm-mob-filtering-label").removeClass("dm-desk-filter-active");
    }
  });
  if($(this).hasClass("dm-desk-filter-active")) {
    $(this).removeClass("dm-desk-filter-active")
  }
  else {
     $(this).addClass("dm-desk-filter-active")
  }
   setTimeout(function(){
     $('.mobile-facets__footer .button').click();
   }, 1000)
});

$(document).on('click', '.mobile-facets__clear-wrapper', function() {
   $(".dm-mobile-sorting-options .dm-desk-sorting-input").removeAttr("checked");
   $(".dm-mob-filtering-input").removeAttr("checked");
   $(".dm-mob-filtering-label").removeClass("dm-desk-filter-active");
   $('body').removeClass("cart-drawer-active");
   $(".new-dm-collection div#ProductGridContainer").css("z-index", "-1 ");  
});

$(document).on('click', '.mobile-facets__open-wrapper', function() {
  $("body").css("overflow", "hidden");
  $('body').addClass("cart-drawer-active");
  $(".new-dm-collection div#ProductGridContainer").css("z-index", "-1 ");     
  $("#shopify-section-header").css("z-index", "0");
});

$(document).on('click', '.mobile-facets__close', function() {
  $("body").css("overflow", "auto");
  $('body').removeClass("cart-drawer-active");
  $(".new-dm-collection div#ProductGridContainer").css("z-index", "1");       
  $("#shopify-section-header").css("z-index", "99");
});

$(document).on('click', '.mobile-facets__footer .button', function() {
   $("body").css("overflow", "auto");
   $('body').removeClass("cart-drawer-active");
   $(".new-dm-collection div#ProductGridContainer").css("z-index", "1");                                  
   $("#shopify-section-header").css("z-index", "99");
});

$(".new-dm-collection .mobile-facets__wrapper .mobile-facets__inner .mobile-facets__main").scroll(function(){
  if($(this).scrollTop() > 6) {
      $(".mobile-facets__header").addClass("dm-header-shadow");
  }
  else {
      $(".mobile-facets__header").removeClass("dm-header-shadow");
  }
});

$(document).on('click', '.button-show-more', function() {
  $(".mobile-facets__wrapper .mobile-facets__disclosure").addClass("menu-opening");
  $(".mobile-facets__disclosure .mobile-facets__open-wrapper").attr("aria-expanded", "true");  
  setTimeout(function(){
    $(".mobile-facets__disclosure").attr("open", "open");
  }, 500)
});